import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  AwardIcon,
  TelescopeV2Icon,
  ToolboxIcon,
  TextLink,
} from 'secondstep-components'

export const StyledTextLink = styled(TextLink)`
  /* Use the theme's button colors for consistency */
  color: ${themeGet('colors.buttons.primary.bgActive')};

  &:hover {
    color: ${themeGet('colors.buttons.secondary.bgHover')} !important;
  }

  &:focus {
    color: ${themeGet('colors.buttons.secondary.bgHover')} !important;
  }

  /* Override any default TextLink styles */
  &:visited {
    color: ${themeGet('colors.buttons.primary.bgActive')};
  }

  &:link {
    color: ${themeGet('colors.buttons.primary.bgActive')};
  }
`

export const StyledTelescope = styled(TelescopeV2Icon)`
  width: 1.25rem;
  color: ${({ theme }) =>
    theme.meta.themeName === 'elementary'
      ? themeGet('colors.elemDigital3')
      : themeGet('colors.darkBlue')};

  /* Apply hover styles when parent is hovered */
  a:hover & {
    color: ${themeGet('colors.buttons.secondary.bgHover')} !important;
  }
`

export const StyledAwardIcon = styled(AwardIcon)`
  width: 1.25rem;

  /* Apply hover styles when parent is hovered */
  a:hover & {
    color: ${themeGet('colors.buttons.secondary.bgHover')} !important;
  }
`

export const StyledToolboxIcon = styled(ToolboxIcon)`
  width: 1.25rem;

  /* Apply hover styles when parent is hovered */
  a:hover & {
    color: ${themeGet('colors.buttons.secondary.bgHover')} !important;
  }
`
